<template>
  <div class="cdnFileManagerTableWrapper">
    <b-row>
      <b-col sm="5">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-folder-o mr-2'></i> Folder Places</h5>
            <div v-if="activeFolder > 0 || activeFolder === ''" class="float-right">
              <b-button v-if="checkAccessPrivilege('System.CDNFileManager.AddFolder')" variant="primary" @click="showAddFolderModal = true">Add Folder</b-button>
            </div>
          </b-card-header>
          <b-card-body>
            <ul class="list-group">
              <li class="rootFolderWrapper" @click="activeFolder = ''" :class="{ rootDirectorySelected : activeFolder === '' }"><i class='fa fa-hdd-o m-2'></i>Computer</li>
              <treeselect v-model="activeFolder" isDefaultExpanded :default-expand-level="1" always-open :max-height="100000" :normalizer="normalizer"  :options="folderList" >
                <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                  <label class="float-left">
                    <i class='fa fa-folder-o mr-2'></i> {{ node.label }}
                  </label>
                  <label v-if="node.id > 0" class="float-right showFolderSettingModal" @click="showFolderSetting(node.label)">
                    <i class='fa fa-cog ml-2'></i>
                  </label>
                </label>
              </treeselect>
            </ul>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="7">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left">Folder Images</h5>
            <template v-if="checkAccessPrivilege('System.CDNFileManager.UploadImage')">
              <div v-if="activeFolder !== ''" class="float-right">
                <b-button :variant="enableFileSelect ? 'success' : 'danger'" class="mx-1" @click="toggleFileSelect">{{ enableFileSelect ? 'Multi Select Enabled' : 'Multi Select Disabled' }}</b-button>
                <template v-if="activeFolder !== 0">
                  <b-button variant="primary" class="mx-1" @click="showUploadImageModal = true">Upload Image</b-button>
                </template>
              </div>
            </template>
          </b-card-header>
          <b-card-body>
            <template v-if="fetchingImagesInFolder">
              <div>
                  Fetching Folder Data...
              </div>
            </template>
            <template v-else>
              <div class="filterWrapper">
                <div v-if="categoryList.length > 1 && activeFolder !== ''">
                  Filter By Category<b-form-select v-model="categoryFilter" :options="categoryList" class="mt-2"/>
                </div>
              </div>
              <hr>
              <div v-if="selectedCardList.length > 0">
                <b-button variant="primary" class="mx-1" @click="showMoveFolderModal = true">Select Folder to move</b-button>
              </div>
              <br>
              <div class="imageListWrapper">
                <div v-for="image in filteredFolderImages" :key="image.Id" class="imageCard" @click="selectedCard(image)" :class="{ active: checkSelected(image) }">
                  <div class="card" style="width: 200px;">
                    <div class="card-img-wrapper">
                      <img class="card-img-top" :src="image.ImgUrl" alt="Card image cap" :key="image.ImgUrl">
                    </div>
                    <div class="card-body">
                      <h4>Category</h4>
                      <p>{{ image.Category }}</p>
                      <hr>
                      <template v-if="checkAccessPrivilege('System.CDNFileManager.FileSetting')">
                        <b-button variant="primary" class="my-1 btn-sm" @click="generateImgUrl(image.ImgUrl)" :disabled="enableFileSelect">Generate Url</b-button>
                        <b-button variant="primary" class="my-1 btn-sm" @click="showEditFolderForImageModal(image)" :disabled="enableFileSelect"><i class='fa fa-pencil'></i></b-button>
                        <template v-if="image.Category === 'file-manager-uploads' && !image.CategoryId">
                          <b-button variant="danger" class="my-1 btn-sm" @click="showRemoveImageModal(image)" :disabled="enableFileSelect"><i class='fa fa-trash'></i></b-button>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <AddFolder :show-add-modal="showAddFolderModal" @cancelAddFolderModal="showAddFolderModal = false" @loadUpdatedData="getFolders" :parentIdx="activeFolder" />
    <UploadImage :show-add-modal="showUploadImageModal" :folderList="folderList" @cancelAddFolderModal="showUploadImageModal = false" @loadUpdatedData="fetchFolderImages" :parentIdx="activeFolder" />
    <FileSettingModal :show-add-modal="showEditImageFolderModal" :folderList="folderList" @cancelAddFolderModal="showEditImageFolderModal = false" @loadUpdatedData="fetchFolderImages" :parentIdx="activeFolder" :selectedImage="selectedImage" />
    <MoveFolderModal :showMoveFolderModal="showMoveFolderModal" :folderList="folderList" @cancelMoveFolderModal="showMoveFolderModal = false" :updateData="selectedCardList" @uploadFolderImages="fetchFolderImages" />
    <b-modal v-model="showImageUrlModal" size="md" centered header-bg-variant="primary" hide-footer title="Image Url" @hide="cancelImgUrlModal()">
      <div class="d-block">
        <b-row>
          <b-col sm="12" v-if="showImageUrlModal">
            <b-row>
              <b-col sm="12">
                <a :href="selectedImageLink" target="_blank" class="cdnImgLinkUrl">
                  <input type="text" v-model="selectedImageLink" id="cdnImgLinkUrlInput">
                </a>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="mt-3" >
            <b-button variant="success" @click="doCopy">
              Copy Link
            </b-button>
            <b-button variant="outline-danger" @click="cancelImgUrlModal()">Cancel</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal v-model="showImageRemoveModal" size="md" centered header-bg-variant="primary" hide-footer title="Remove Image" @hide="cancelImgRemoveModal()">
      <div class="d-block">
        <b-row>
          <b-col sm="12" v-if="showImageRemoveModal">
            <b-row>
              <b-col sm="12" class="centerContentFileManager">
                <p>Are you sure, you want to delete this image ?</p>
              </b-col>
            </b-row>
          </b-col>
          <br>
          <br>
          <b-col sm="12" class="centerContentFileManager">
            <b-button variant="success" @click="removeFileManagerUploadedImage()" :disabled="buttonActionInProcessRemoveImageModal">Yes</b-button>
            <b-button variant="danger" @click="cancelImgRemoveModal()" :disabled="buttonActionInProcessRemoveImageModal">No</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal v-model="showFolderSettingModal" size="md" centered header-bg-variant="primary" hide-footer title="Folder Setting" @hide="cancelFolderSetting()">
      <div class="d-block">
        <b-row>
          <b-col sm="12" v-if="showFolderSettingModal">
            <b-row>
              <b-col sm="12">
                <p>
                  Folder: 
                  <strong class="selectedFolderWrapper">
                    {{ selectedFolderName }}
                  </strong>
                </p>
                <template v-if="selectedfolderSettingOption === ''">
                  <div class="settingOptions">
                    <b-button variant="primary" @click="selectedfolderSettingOption = 'rename'">Rename Folder</b-button>
                  </div>
                </template>
                <template v-else>
                  <div v-if="selectedfolderSettingOption = 'rename'">
                    <b-row>
                      <b-col sm="12">
                        <p-input v-model="form.folderName" label="Enter New Folder Name" name="folderName" :handler="$v" :formData="form" type="text" />
                      </b-col>
                      <b-col sm="12" >
                        <b-button variant="primary" @click="renameFolder()" :disabled="renameFolderProcessing">Rename Folder</b-button>
                        <b-button variant="outline-danger" @click="selectedfolderSettingOption = ''" :disabled="renameFolderProcessing">Back</b-button>
                      </b-col>
                    </b-row>
                  </div>
                </template>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'
import {Events} from '../../events.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import AddFolder from './AddFolder'
import UploadImage from './UploadImage'
import FileSettingModal from './FileSettingModal'
import MoveFolderModal from './MoveFolderModal'
import { PInput } from '../../components'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'set-operator-group-privilege',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      selectedfolderSettingOption: '',
      categoryFilter: null,
      folderImages: [],
      fetchingImagesInFolder: false,
      activeFolder: '',
      folderList: [],
      showAddFolderModal: false,
      showUploadImageModal: false,
      selectedImageLink: '',
      showImageUrlModal: false,
      showImageRemoveModal: false,
      buttonActionInProcessRemoveImageModal: false,
      showFolderSettingModal: false,
      selectedFolderName: '',
      selectedImage: {},
      renameFolderProcessing: false,
      showEditImageFolderModal: false,
      perPage: 10,
      currentPage: 1,
      form: {
        folderName: '',
        errorMessages: {
          folderName: {
            required: 'Folder Name is required'
          }
        }
      },
      enableFileSelect: false,
      selectedCardList: [],
      showMoveFolderModal: false
    }
  },
  validations: {
    form: {
      folderName: {
        required
      }
    }
  },
  components: {
    Treeselect,
    AddFolder,
    UploadImage,
    PInput,
    FileSettingModal,
    MoveFolderModal
  },
  computed: {
    categoryList: function () {
      const list = [...new Set(this.folderImages.map(x => x.Category))]
      const categoryList = list.map(x => {
        return {
          text: x,
          value: x
        }
      })
      return [ { text: 'All', value: null }, ...categoryList ]
    },
    filteredFolderImages: function () {
      return this.categoryFilter !== null ? this.folderImages.filter(x => x.Category === this.categoryFilter) : this.folderImages
    }
  },
  watch: {
    activeFolder: function (val) {
      this.categoryFilter = null
      this.enableFileSelect = false
      this.selectedCardList = []
      if (val !== '') {
        if (val === 0 || val === -1) {
          this.getNonFolderImages()
        } else {
          this.fetchFolderImages()
        }
      } else {
        this.folderImages = []
      }
    }
  },
  methods: {
    checkAccessPrivilege (module) {
      if (!module) return true
      return this.PRIVILEGE.includes(module)
    },
    checkSelected (image) {
      const imageId = image.Id
      return this.selectedCardList.includes(imageId)
    },
    toggleFileSelect () {
      if (this.enableFileSelect) {
        this.selectedCardList = []
      }
      this.enableFileSelect = !this.enableFileSelect
    },
    selectedCard (image) {
      if (!this.enableFileSelect) {
        return
      }
      const imageId = image.Id
      if (this.selectedCardList.includes(imageId)) {
        const findIndex = this.selectedCardList.findIndex(x => x === imageId)
        this.selectedCardList.splice(findIndex, 1)
      } else {
        this.selectedCardList.push(imageId)
      }
    },
    doCopy () {
      var copyText = document.getElementById('cdnImgLinkUrlInput')
      copyText.select()
      document.execCommand('copy')
      Events.$emit('alert', VueNotifications.types.success, 'Success', 'Image Url Copied')
    },
    async showEditFolderForImageModal (image) {
      this.selectedImage = image
      this.showEditImageFolderModal = true
    },
    async getNonFolderImages () {
      try {
        let categoryName
        if (this.activeFolder === 0) {
          categoryName = 'others'
        } else {
          categoryName = 'file-manager-static-uploads'
        }
        const { data } = await this.$http.get(this.API_ENDPOINT + `/fileManager/image/getNonFolderImages?category=${categoryName}`, { headers: { 'Content-Type': 'application/json' } })
        this.folderImages = data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async renameFolder () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        } else {
          this.renameFolderProcessing = true
          const payload = {
            folderId: this.activeFolder,
            folderName: this.form.folderName
          }
          await this.$http.post(this.API_ENDPOINT + '/fileManager/folder/rename', payload, { headers: { 'Content-Type': 'application/json' } })
          this.getFolders()
          this.cancelFolderSetting()
        }
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong while fetchinf folder images')
      } finally {
        this.renameFolderProcessing = false
      }
    },
    showFolderSetting (folderName) {
      this.selectedFolderName = folderName
      this.showFolderSettingModal = true
    },
    cancelFolderSetting () {
      this.selectedfolderSettingOption = ''
      this.selectedFolderName = ''
      this.form.folderName = ''
      this.showFolderSettingModal = false
    },
    cancelImgRemoveModal () {
      this.showImageRemoveModal = false
      this.selectedImage = {}
    },
    showRemoveImageModal (imageData) {
      this.showImageRemoveModal = true
      this.selectedImage = imageData
    },
    generateImgUrl (link) {
      this.selectedImageLink = link
      this.showImageUrlModal = true
    },
    async fetchFolderImages () {
      try {
        if (this.activeFolder < 1) {
          this.getNonFolderImages()
          return
        }
        this.fetchingImagesInFolder = true
        const payload = {
          folderId: this.activeFolder
        }
        const { data } = await this.$http.post(this.API_ENDPOINT + '/fileManager/image/getImagesInFolder', payload, { headers: { 'Content-Type': 'application/json' } })
        this.folderImages = data.list
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong while fetchinf folder images')
      } finally {
        setTimeout(() => {
          this.fetchingImagesInFolder = false
        }, 200)
      }
    },
    normalizer (node) {
      return {
        id: node.Id,
        label: node.Name,
        children: node.children
      }
    },
    async addFolder () {
      try {
        await this.$http.get(this.API_ENDPOINT + '/fileManager/addFolder', { headers: { 'Content-Type': 'application/json' } })
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async getFolders () {
      try {
        const { data } = await this.$http.get(this.API_ENDPOINT + '/fileManager/getFolderList', { headers: { 'Content-Type': 'application/json' } })
        this.folderList = data.list
        const otherFolder = [
          {
            Id: 0,
            Name: 'Other Images',
            ParentIdx: null,
            children: []
          },
          {
            Id: -1,
            Name: 'Alway same Img Url (Image Folder)',
            ParentIdx: null,
            children: []
          }
        ]
        this.folderList = [ ...this.folderList, ...otherFolder ]
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    cancelImgUrlModal () {
      this.selectedImageLink = ''
      this.showImageUrlModal = false
    },
    async removeFileManagerUploadedImage () {
      try {
        this.buttonActionInProcessRemoveImageModal = true
        const payload = {
          PictureId: this.selectedImage.Id
        }
        await this.$http.post(this.API_ENDPOINT + '/fileManager/image/remove', payload, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Image Removed Successfully')
        this.fetchFolderImages()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.cancelImgRemoveModal()
        this.buttonActionInProcessRemoveImageModal = false
      }
    }
  },
  async created () {
    this.getFolders()
  }
}
</script>

<style>
.vue-treeselect__menu-container {
  position: static !important;
}
.vue-treeselect__menu {
  position: static !important;
  max-height: auto !important;
}
.vue-treeselect__tip.vue-treeselect__no-children-tip {
  display: none;
}
.vue-treeselect__control {
  display: none !important;
}

.cdnFileManagerTableWrapper .imageListWrapper {
  display: flex;
  flex-wrap: wrap;
  border-radius: 5px;
  overflow: hidden;
}

.cdnFileManagerTableWrapper .imageListWrapper .active .card {
  border: 2px solid #20a8d8
}

.cdnFileManagerTableWrapper .filterWrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.cdnFileManagerTableWrapper .filterWrapper > div {
  max-width: 300px;
}


.cdnFileManagerTableWrapper .imageListWrapper .card-img-wrapper {
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cdnFileManagerTableWrapper .imageListWrapper .card-img-wrapper img {
  width: auto;
  max-height: 120px;
  max-width: 200px;
}

.showFolderSettingModal {
  z-index: 10;
  cursor: pointer;
}

.cdnFileManagerTableWrapper .imageListWrapper .imageCard {
  margin: 2.5px 5px;
}

.imageCard .card {
  margin-bottom: 5px
}
#cdnImgLinkUrlInput {
  width: 100%;
  border: none;
  cursor: pointer;
  color: #20a8d8;
  text-overflow: ellipsis;
  border: 1px solid #c4c4c4;
  padding: 5px 10px;
  border-radius: 10px;
}

.cdnImgLinkUrl {
  word-break: break-all;
  display: block;
  width: 100%;
}

.cdnFileManagerTableWrapper .vue-treeselect__option--selected, .selectedFolderWrapper {
  color: #20a8d8
}

.centerContentFileManager {
  text-align: center;
}

.rootFolderWrapper {
  list-style-type: none;
  display: flex;
  align-items: center;
  padding-left: 20px;
  background: #f5f5f5;
}

.rootFolderWrapper i {
  font-size: 1.5rem;
}

.rootDirectorySelected {
  color: #20a8d8;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/cdnFileManager/CDNFileManagerTable.vue